import { useUiStore } from 'app/core/store_v2/ui';
import { isInspector } from 'app/helpers/userRoles';
import { setCurrentApp } from 'app/store/auth';
import SynchronizeIcon from 'app/ui/icons/SynchronizeIcon';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Box, Drawer, IconButton, MenuItem, SxProps, Theme, useTheme } from '@mui/material';

import { RootState } from '../../../store/rootReducer';
import { getApps } from './Navigation/config';

const navbarHeight = 64;

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    drawerContainer: {
      position: 'relative',
    },
    drawerModal: {
      zIndex: 1298,
      '& .MuiDrawer-root': {
        zIndex: 1298,
      },
    },
    navbar: {
      top: navbarHeight,
    },
    menuItem: {
      padding: '12px 20px',
      width: '100%',
      fontSize: '1.6rem',

      '& .iconContainer': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: theme.spacing(2),
        color: theme.palette.info.light,
      },
      '&:hover': {
        background: theme.palette.grey[200],
        color: '#213a6d',
        '& .iconContainer': {
          color: '#213a6d',
        },
      },
      '&[aria-disabled="true"]': {
        opacity: 0.5,
      },
    },
    iconButton: {
      height: navbarHeight,
      borderRadius: 0,
      marginLeft: 1,
    },
    buttonIndicator: {
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      height: '4px',
      borderRadius: '2px',
      zIndex: 10,
      background: '#ad3838',
    },
  };
};

export default function UserMenuMobile() {
  const dispatch = useDispatch();
  const { user, currentApp } = useSelector((state: RootState) => state.auth);
  const { topUserMenu, setUserMenu } = useUiStore();

  const theme = useTheme();
  const styles = getStyles(theme);
  const navigate = useNavigate();

  const handleClick = () => {
    if (topUserMenu) {
      handleClose();
      return;
    }
    setUserMenu('bottom', false);
    setUserMenu('top', true);
  };

  const handleMenuClick = (url: string, id: string, isExternal: boolean) => {
    if (!isExternal) {
      navigate(url);
    }

    if (isExternal) {
      window.location.href = url;
    }

    if (id !== 'admin-panel') {
      dispatch(setCurrentApp(id));
    }
    handleClose();
  };

  const handleClose = () => {
    setUserMenu('top', false);
  };

  if (!user || isInspector(user)) {
    return null;
  }

  return (
    <>
      <IconButton aria-label="Switch Application" onClick={handleClick} sx={styles.iconButton}>
        <SynchronizeIcon />
        {topUserMenu && <Box sx={styles.buttonIndicator}></Box>}
      </IconButton>

      <Drawer
        anchor="top"
        variant="temporary"
        open={topUserMenu}
        onClose={handleClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        PaperProps={{
          sx: styles.navbar,
        }}
      >
        <>
          {getApps(user).map((item) => (
            <MenuItem
              key={item.id}
              onClick={() => {
                handleMenuClick(item.homeUrl, item.id, item?.isExternal || false);
              }}
              disabled={item.id === currentApp && item.id !== 'admin-panel'}
              sx={styles.menuItem}
            >
              <span className="iconContainer">
                <SynchronizeIcon color="primary" />
              </span>
              {item.name}
            </MenuItem>
          ))}
        </>
      </Drawer>
    </>
  );
}
